import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxPopupModule, DxNumberBoxModule, DxButtonModule, DxToolbarModule } from 'devextreme-angular';
import { SharedModule } from '../../../../shared/shared.module';
import { PlanningLoadunits } from '../../../../shared/planning/PlanningLoadunit';
import {
  BadgeVariantComponent,
  Shape,
} from '../../../../shared/components/badge-variant/badge-variant/badge-variant.component';

@Component({
  selector: 'app-planning-dialog',
  standalone: true,
  imports: [
    BadgeVariantComponent,
    CommonModule,
    DxPopupModule,
    DxNumberBoxModule,
    DxButtonModule,
    DxToolbarModule,
    SharedModule,
  ],
  templateUrl: './planning-dialog.component.html',
  styleUrl: './planning-dialog.component.scss',
})
export class PlanningDialogComponent {
  visible = input(false);
  currentPlanning = input<PlanningLoadunits | undefined>(undefined);
  projectAdrPointsTotal = input(0);

  dialogClosed = output<void>();
  execute = output<void>();

  readonly Shape = Shape;

  closePlanningDialog(): void {
    this.dialogClosed.emit();
  }

  executeCurrentPlanning(): void {
    this.execute.emit();
  }

  finishText(): string {
    return this.currentPlanning()?.truck.overload() || this.currentPlanning()?.trailer.overload()
      ? 'PROJECT_PLANNING.FINISH_OVERLOAD'
      : 'PROJECT_PLANNING.FINISH';
  }
}
